<template>
  <div :class="ticket.status === 3 ? 'text-text-ternary' : 'text-text'"
       class="py-4 bg-block ticket-item-grid hover:text-red cursor-pointer transition duration-200"
       @click="navigateToTicket">
    <div class="text-text-ternary text-2sm -ml-0-5 hidden lg:block">
      {{ $moment.unix(ticket.updated_at).format('DD.MM.YY, HH:mm') }}
    </div>
    <div class="font-bold text-sm -ml-0-5 truncate">{{ subjectLabel }}</div>
    <div class="text-2sm -ml-0-5 truncate">{{ ticket.title }}</div>
    <div class="ml-auto">
      <TicketStatusBadge :status="ticket.status"/>
    </div>
  </div>
</template>

<script>
import TicketStatusBadge from "@/components/cabinet/Tickets/TicketStatusBadge";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "TicketSystemListItem",
  components: {TicketStatusBadge},
  props: {
    ticket: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapGetters('cabinet/constants', ['getConstantList']),
    ticketStatus() {
      return this.getConstantList('ticket_status')
    },
    ticketSubject() {
      return this.getConstantList('ticket_subject')
    },
    subjectLabel() {
      return this.ticketSubject[this.ticket.subject - 1].name
    },
  },
  methods: {
    ...mapActions('cabinet/tickets', ['setCurrentTicket']),
    navigateToTicket() {
      this.setCurrentTicket(this.ticket)
      this.$router.push({name: 'ticket-chat', params: {ticketId: this.ticket.id}})
    }
  }
}
</script>